"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const folder_1 = require("../../../server/models/folder");
const FoldersRoute_1 = __importDefault(require("../../../routes/FoldersRoute"));
const folderId_1 = require("../../constants/folderId");
const lodash_1 = __importDefault(require("lodash"));
const useFolderBreadcrumbs = ({ currentFolder, }) => {
    const isMounted = (0, react_1.useRef)(true);
    const [isFetchingAncestors, setIsFetchingAncestors] = (0, react_1.useState)(true);
    const [folderAncestors, setFolderAncestors] = (0, react_1.useState)(undefined);
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleErrors = () => {
        return [false, null];
    };
    const getFolderAncestorsForBreadcrumbs = (0, react_1.useCallback)(() => {
        if (!currentFolder)
            return updateFolderAncestors(undefined);
        setFolderAncestors(undefined);
        setIsFetchingAncestors(true);
        (0, folder_1.getFolderAncestors)(currentFolder.id)
            .then(updateFolderAncestors)
            .catch(() => handleErrors);
    }, [currentFolder]);
    const updateFolderAncestors = (res) => {
        if (isMounted.current) {
            setFolderAncestors(res?.length ? res : undefined);
            setIsFetchingAncestors(false);
        }
    };
    const getFolderBreadcrumbs = () => {
        const routes = folderAncestors
            ?.filter((x) => x.id !== folderId_1.embedUserFolderId)
            .map((x) => {
            if (x.id === folderId_1.rootFolderId || x.id === folderId_1.embedGroupFolderId) {
                return {
                    displayName: `${t('folderHeader')}`,
                    path: `${FoldersRoute_1.default.path}`,
                };
            }
            if (x.isPersonal === true) {
                return {
                    displayName: `${x.name}'s ${t('folder')}`,
                    path: `${FoldersRoute_1.default.path}/${x.id}`,
                };
            }
            return {
                displayName: x.friendlyName,
                path: `${FoldersRoute_1.default.path}/${x.id}`,
            };
        });
        if (currentFolder?.isPersonal)
            routes?.push({
                displayName: `${currentFolder?.friendlyName}'s ${t('folder')}`,
                path: '',
            });
        else if (currentFolder?.name)
            routes?.push({ displayName: currentFolder?.friendlyName, path: '' });
        if (routes && routes.length > 3) {
            const shortListOfRoutes = lodash_1.default.takeRight(routes, 3);
            shortListOfRoutes.unshift({
                displayName: '...',
                path: routes[0].path,
            });
            return shortListOfRoutes;
        }
        return routes;
    };
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        getFolderAncestorsForBreadcrumbs();
        return () => {
            isMounted.current = false;
        };
    }, [getFolderAncestorsForBreadcrumbs]);
    return [isFetchingAncestors, getFolderBreadcrumbs()];
};
exports.default = useFolderBreadcrumbs;
